import { ProdStackInfo } from 'types/state';
import { createUniqueRuntimeNumber } from 'utils/uniqueRuntimeNumberUtils';

export const createProdStackInfo = (): ProdStackInfo => ({
  id: 0,
  subdomain: null,
  originURL: null,
  loginURL: null,
  loginHash: null,
  category: null,
  updatedOn: null,
  trialDue: null,
  licenseDue: null,
  licensesCount: 0,
  firstLogin: null,
});

export const createProdStackInfoMock = (): ProdStackInfo => ({
  id: createUniqueRuntimeNumber(),
  subdomain: 'prod15',
  originURL: 'https://prod15.fake.url',
  loginURL: 'https://prod15.fake.url/login',
  loginHash: 'my_hash',
  category: 'MINI',
  updatedOn: null,
  trialDue: null,
  licenseDue: null,
  licensesCount: 0,
  firstLogin: 'my_login',
});
